export enum CommitStatus {
  Commit = 'Commit',
  WillCall = 'Will Call',
  Cancelled = 'Cancelled',
  OnHold = 'On Hold',
  WeatherHold = 'Weather Hold',
  Pending = 'Pending',
  InterventionRequired = 'Intervention Required'
}
